import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch, ref } from 'vue';
import * as moment from "moment";
import { isOrionTelemetry, isOrionTelemetryAvailable, isOrionTelemetryServiceNotRunning, isServiceError, isServiceSuccess, ServiceResult } from '@/data.types';

interface Props {
  data: ServiceResult
}

export default /*#__PURE__*/_defineComponent({
  __name: 'telemetry-status-display',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ServiceResult
};

function datetime(value: moment.Moment) {
  return value.format("DD.MM.YYYY HH:mm:ss");
}


const data = computed(() => props.data)

let socketTimeout: number;
let socketConnection = ref<string>('stale'); // 'ok' | 'stale'

const timestamp = computed(() => {
  let timestamp = moment.utc(0);
  if (isServiceSuccess(data.value) && isOrionTelemetry(data.value.data)) {
    timestamp = moment.utc(data.value.data.metadata.timestamp);
  }
  return timestamp;
})

const error = computed(() => {
  let error = {
    "color": "teal",
    "short": "client error",
    "detail": "Not initialized."
  }

  if (isServiceSuccess(data.value)) {
    if (isOrionTelemetry(data.value.data)) {
      if (isOrionTelemetryAvailable(data.value.data)) {
        error = {
          "color": "green",
          "short": "ok",
          "detail": "connected, data is streaming"
        }
      } else if (isOrionTelemetryServiceNotRunning(data.value.data)) {
        error = {
          "color": "orange",
          "short": "no data (NASA)",
          "detail": "connected, NASA/JPL data-service not running"
        }
      } else {
        error = {
          "color": "red",
          "short": "LOS",
          "detail": "Loss of signal"
        }
      }
    } else {
      error = {
        "color": "teal",
        "short": "Data error",
        "detail": "Invalid data from backend!"
      }
    }
  } else if (isServiceError(data.value)) {
    error = {
      "color": "teal",
      "short": "connection error",
      "detail": `${data.value.error.name}: ${data.value.error.message}`
    }
  }
  return error;
})

onMounted(() => {
})

watch(data, (val) => {
  socketConnection.value = "ok"
  if (socketTimeout) clearTimeout(socketTimeout);
  socketTimeout = setTimeout(() => {
    socketConnection.value = "stale"
  }, 5000)
})

return { __sfc: true,datetime, props, data, socketTimeout, socketConnection, timestamp, error }
}

})